<template>
    <div v-if="dgstfnExmnUseYn == 'Y'" class="menu-satisfaction ">
        <div v-if="rspnsYn == 'N'" class="satisfaction-wrap">
            <div class="layout">
                <div class="check-list">
                    <label class="form-title">{{ pgNm }} 만족도 조사</label>
                    <div class="check-area">
                        <div class="form-check">
                            <input type="radio" name="rspns" id="rspns5" class="mr5" v-model="checkRspns"
                                value="5" />
                            <label for="rspns5">매우 만족</label>
                        </div>
                        <div class="form-check">
                            <input type="radio" name="rspns" id="rspns4" class="mr5" v-model="checkRspns"
                                value="4" />
                            <label for="rspns4">만족</label>
                        </div>
                        <div class="form-check">
                            <input type="radio" name="rspns" id="rspns3" class="mr5" v-model="checkRspns"
                                value="3" />
                            <label for="rspns3">보통</label>
                        </div>
                        <div class="form-check">
                            <input type="radio" name="rspns" id="rspns2" class="mr5" v-model="checkRspns" value="2" />
                            <label for="rspns2">불만족</label>
                        </div>
                        <div class="form-check">
                            <input type="radio" name="rspns" id="rspns1" class="mr5" v-model="checkRspns" value="1" />
                            <label for="rspns1">매우 불만족</label>
                        </div>
                    </div>
                </div>
                <div class="layout write-zone">
                    <input type="text" class="form-control sm" v-model="menuDgstfn.opnn" placeholder="의견을 남겨주세요" maxlength="50"/>
                    <button class="btn sm" @click="save">제출</button>
                </div>
            </div>
        </div>
        <div v-else-if="rspnsYn == 'Y'" class="satisfaction-wrap">
            <label class="form-title">설문에 참여해주셔서 감사합니다.</label>
        </div>
    </div>
    <div v-else>
    </div>
</template>

<script>
import { defaultMenuDgstfnParams } from '../../resources/js/defaultMenuSatisfactionParams.js';
import { menuFindMenuDgstfn } from '../../resources/api/menu.js';
import { findByMenuId, save } from '../../resources/api/menuDgstfn.js';

export default {
    data() {
        return {
            mbrNm: this.$store.state.mbrNm,
            pgNm: this.$store.state.menu && this.$store.state.menu.menuNm ? this.$store.state.menu.menuNm : "홈",
            menuId: null,

            dgstfnExmnUseYn: "N", // 메뉴 만족도 사용 여부
            rspnsYn: 'N', // 응답 여부
            checkRspns: '', // '5' ~ '1' 중 하나
            menuDgstfn: { ...defaultMenuDgstfnParams }, // 메뉴 만족도
        }
    },
    created() {
    },
    methods: {
        // 상세 조회
        async fnView() {
            this.dgstfnExmnUseYn = 'N';
            this.rspnsYn = 'N';
            const reqMenuId = this.menuId; // 요청 시점 메뉴
            try {
                this.checkRspns = ''; // 응답 초기화
                this.menuDgstfn = { ...defaultMenuDgstfnParams }; // 응답 초기화
                const res = await menuFindMenuDgstfn({ menuId: reqMenuId });
                // 응답 도착 전 다른 메뉴로 이동했으면 무시
                if (reqMenuId !== this.menuId) return;
                if (res.status == 200) {
                    this.dgstfnExmnUseYn = res.data.data.dgstfnExmnUseYn;

                    this.$emit('menuChecck', this.dgstfnExmnUseYn);
                    if (res.data.data.dgstfnExmnUseYn == 'Y') {
                        this.fnViewByMenuId();
                    }
                }
                // 부모에게 전달
            } catch (error) {
                if (reqMenuId !== this.menuId) return;
                console.error("메뉴 만족도 조회 실패:", error);
                this.dgstfnExmnUseYn = 'N';
                this.$emit('menuChecck', 'N');
            }
        },

        // 만족도 응답 이력 조회
        async fnViewByMenuId() {
            const reqMenuId = this.menuId; // 요청 시점 메뉴
            try {
                const res = await findByMenuId({ menuId: reqMenuId });
                // 응답 도착 전 다른 메뉴로 이동했으면 무시
                if (reqMenuId !== this.menuId) return;
                if (res.status == 200) {
                    if (res.data.data != null) {
                        this.rspnsYn = 'Y'; // 응답
                    } else {
                        this.rspnsYn = 'N'; // 미응답
                    }
                }
            } catch (error) {
                if (reqMenuId !== this.menuId) return;
                console.error("만족도 응답 이력 조회 실패:", error);
                this.rspnsYn = 'N';
            }
        },

        // 저장
        async save() {
            try {
                // 응답 값 체크
                if (!this.checkRspnsVal()) {
                    return;
                }
                this.menuDgstfn.menuId = this.menuId; // 메뉴 ID
                const res = await save(this.menuDgstfn);
                if (res.status == 200) {
                    alert("설문에 참여해주셔서 감사합니다.");
                    this.fnView(); // 메뉴 상세 조회
                }
            } catch (error) {
                alert(error.response?.data?.message ?? "에러가 발생했습니다.\n관리자에게 문의해주세요.");
            }
        },

        // 선택 응답값 체크
        checkRspnsVal() {
            if (this.checkRspns == null || this.checkRspns == '') {
                alert("응답을 선택해주세요.");
                return false;
            }

            if (this.menuDgstfn.opnn != null && this.menuDgstfn.opnn != '') {
                if(this.menuDgstfn.opnn.length > 50) {
                    alert("의견은 50자 이내로 입력해주세요.");
                    return false;
                }
            }
            const rspnsVal = this.checkRspns;
            this.menuDgstfn.rspns5 = rspnsVal === '5' ? 'Y' : 'N';
            this.menuDgstfn.rspns4 = rspnsVal === '4' ? 'Y' : 'N';
            this.menuDgstfn.rspns3 = rspnsVal === '3' ? 'Y' : 'N';
            this.menuDgstfn.rspns2 = rspnsVal === '2' ? 'Y' : 'N';
            this.menuDgstfn.rspns1 = rspnsVal === '1' ? 'Y' : 'N';
            return true;
        }

    },
    watch: {
        $route: {
            immediate: true,
            handler(to) {
                if (this.$store.state.menu && to.path !== this.$filters.ctxPath('/adm/main.page') && !to.path.includes('/view.page') && !to.path.includes('/insert.page')) {
                    this.pgNm = this.$store.state.menu.menuNm;
                    this.menuId = this.$store.state.menu.menuId;
                    this.fnView();
                } else {
                    this.dgstfnExmnUseYn = 'N'; // 초기화
                }
            }
        },

        '$store.state.menu'(newValue) {
            if (newValue && (newValue.isOwnPath === undefined || newValue.isOwnPath === true)) {
                this.pgNm = newValue.menuNm;
                this.menuId = newValue.menuId;
                this.fnView();
            } else {
                this.$emit('menuChecck', 'N');
            }
        },
    },
    computed: {
        pgNm() {
            return this.$store.state.menu && this.$store.state.menu.menuNm ? this.$store.state.menu.menuNm : "홈";
        }
    },
    mounted() {

    }
}
</script>